import axios from 'axios'
import moment from 'moment'
import qs from 'qs'
export const getHotSwapById = async id => {
    try {
        const response = await axios.get(
            `${process.env.API_URL}/hotswaps/${id}`
        )
        return response.data
    } catch (error) {
        throw new Error(
            error.response ? error.response.data.message : 'Network error'
        )
    }
}

export async function getHotswapsFileForExport(params) {
    const response = await axios
        .get(`${process.env.API_URL}/hotswaps/export`, {
            responseType: 'blob',
            params,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })
        .catch(err => {
            console.error(err)
            return null
        })
    return response?.data
}

export async function getHotswapWeeks(limit) {
    const response = await axios
        .get(`${process.env.API_URL}/hotswaps/weeks`) // ?limit=${limit}
        .catch(err => {
            console.error(err)
            return null
        })
    return response?.data
}

export async function getHotswapWeeksAvailabilityByLocationIds(locations) {
    const response = await axios
        .get(
            `${process.env.API_URL}/hotswaps/weeks/availability?locations=${locations}`
        )
        .catch(err => {
            console.error(err)
            return null
        })
    return response?.data
}

export async function getHotswapFileForExport(id, params) {
    const dateNow = moment(new Date()).format('DD.MM.YYYY')
    const timeNow = moment(new Date()).format('HH:mm')
    params = { ...params, dateNow, timeNow }
    const response = await axios
        .get(`${process.env.API_URL}/hotswaps/${id}/export`, {
            responseType: 'blob',
            params,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })
        .catch(err => {
            console.error(err)
            return null
        })
    return response?.data
}
